import DesignSystem from 'design-system-utils';
import theme from './base-theme';
export default new DesignSystem(theme, {
  fontSizeUnit: 'px'
});